module.exports = __webpack_public_path__ + "img/gear-J_188x188.8a735716.png";